import type { SlotId } from "../../schemas/index.ts";
import type { GetDesignerNodeDataById } from "./getDesignerNodeData.ts";
import type { GetNodeSlotId } from "./getNodeSlotId.ts";
import type { GetPlaceholderId } from "./getPlaceholderId.ts";

export const getPlaceholderDataCreate =
  (getPlaceholderId: GetPlaceholderId, getDesignerNodeById: GetDesignerNodeDataById) => (slotId: SlotId) => {
    const placeholderId = getPlaceholderId(slotId);
    return placeholderId ? getDesignerNodeById(placeholderId) : undefined;
  };

export type GetPlaceholderData = ReturnType<typeof getPlaceholderDataCreate>;

export const getPlaceholderDataForIdCreate =
  (getSlotIdById: GetNodeSlotId, getPlaceholder: GetPlaceholderData) => (id: number) => {
    const slotId = getSlotIdById(id);
    if (!slotId) {
      return undefined;
    }
    const placeholder = getPlaceholder(slotId);
    if (placeholder?.id === id) {
      return undefined;
    }
    return placeholder;
  };

export type GetPlaceholderDataForId = ReturnType<typeof getPlaceholderDataForIdCreate>;
